import { useEffect } from 'react';

import { ArrowBack, DashboardOutlined } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router';

import useUserDetails from '@/hooks/useUserDetails';

const buttonStyles = {
  width: 250,
  display: 'flex',
  justifyContent: 'flex-start',
  textTransform: 'none',
  mb: 3,
  backgroundColor: 'info.light',
  '&:hover': {
    backgroundColor: 'info.dark'
  }
};

const SuccessScreen = ({
  setExported,
  setPreviewOptionId
}: {
  setExported: (newExported: boolean) => void;
  setPreviewOptionId: (newId: string) => void;
}) => {
  useEffect(
    () => () => {
      setExported(false);
    },
    []
  );
  const { userEmail } = useUserDetails();

  return (
    <Box
      sx={{
        // mt: 12,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography
        fontSize='24px'
        sx={{ textAlign: 'center' }}
      >
        We're on it.
        <br /> You will get an email shortly to
      </Typography>
      <Typography
        fontSize='24px'
        sx={{ mt: 2, mb: 4, textDecoration: 'underline' }}
      >
        {userEmail}
      </Typography>
      <Button
        startIcon={<ArrowBack />}
        sx={buttonStyles}
        variant='contained'
        onClick={() => {
          setExported(false);
          setPreviewOptionId('');
        }}
      >
        Back to Data Hub
      </Button>
      <Button
        component={Link}
        startIcon={<DashboardOutlined />}
        sx={buttonStyles}
        to='/markets'
        variant='contained'
      >
        Go to Markets
      </Button>
    </Box>
  );
};

export default SuccessScreen;
